import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-xl p-4 shadow hover:shadow-xl transition-shadow cursor-pointer border-t-[2px] border-black h-full flex flex-col justify-between" }
const _hoisted_2 = { class: "bg-white text-black rounded-lg flex flex-col justify-between h-full" }
const _hoisted_3 = { class: "mt-4 flex-1" }
const _hoisted_4 = { class: "text-left text-xs" }
const _hoisted_5 = { class: "flex justify-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.query.description.main), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDetails && _ctx.goToDetails(...args))),
          class: "bg-[#157813] hover:bg-[#296b1e] text-white px-3 py-2 rounded-lg hover:shadow-lg transition-all text-sm font-bold"
        }, " See Details ")
      ])
    ])
  ]))
}